<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
document.addEventListener('DOMContentLoaded', function() {
    var menuItems = document.querySelectorAll('.menu-lv-item.has-megamenu');
    var timer;

    menuItems.forEach(function(item) {
        var dropdown = item.querySelector('.menu-dropdown');

        item.addEventListener('mouseover', function() {
            timer = setTimeout(function() {
                var dropdown = item.querySelector('.menu-dropdown');
                dropdown.classList.add('active');
            }, 500);
        });

        dropdown.addEventListener('mouseover', function() {
            dropdown.classList.add('active');
        });

        item.addEventListener('mouseout', function() {
            clearTimeout(timer);
            var dropdown = item.querySelector('.menu-dropdown');
            dropdown.classList.remove('active');
        });

        dropdown.addEventListener('mouseout', function() {
            clearTimeout(timer);
            dropdown.classList.remove('active');
        });
    });
});